var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBuy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M159.037 88.6892C171.257 91.8529 180.998 77.1074 174.916 66.8304C173.201 63.9333 170.013 61.1989 169.388 65.9639C169.021 68.7665 171.119 70.3005 173.386 71.178C178.227 73.0519 180.966 72.0055 184.914 68.8059C189.061 65.4453 191.974 59.5608 193.626 54.5433",
    stroke: "#313D53",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M168 109.041C169.781 106.525 173.535 102.613 173.779 99.3795",
    stroke: "#313D53",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M171.309 22L169.999 35.9386L183.938 37.2481C184.661 29.55 179.007 22.7232 171.309 22Z",
    fill: "#E9688A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M160.731 118.615C160.731 120.281 159.37 121.731 157.615 121.731C155.861 121.731 154.5 120.281 154.5 118.615C154.5 116.982 155.982 115.5 157.615 115.5C159.248 115.5 160.731 116.982 160.731 118.615Z",
    stroke: "#313D53",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7307 62.6153C52.7307 64.2811 51.3699 65.7307 49.6153 65.7307C47.8607 65.7307 46.5 64.2811 46.5 62.6153C46.5 60.9823 47.9823 59.5 49.6153 59.5C51.2484 59.5 52.7307 60.9823 52.7307 62.6153Z",
    stroke: "#313D53",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2715 53.2319L41.2307 54.2997L42.2985 40.3405C34.589 39.7508 27.8612 45.5225 27.2715 53.2319Z",
    fill: "#E9688A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M132.46 98.4489L115.138 148.456C114.583 150.09 112.918 151.075 111.219 150.774L43.3939 138.761L41.0161 96.3137C40.9015 94.2195 42.6443 92.4966 44.7371 92.6353L132.46 98.4489Z",
    fill: "#F7BA97"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M134.592 91.17L140.142 72.1537C140.585 70.6371 141.994 69.6091 143.573 69.6506L154.391 69.9344L161.141 70.1116M134.592 91.17L114.173 151.297M134.592 91.17L114.536 89.8408L94.479 88.5116L74.4223 87.1824L54.3656 85.8532L36.6011 84.6759C34.518 84.5378 32.7832 86.2528 32.8973 88.3373L35.5812 137.377M114.173 151.297L98.1282 148.455L82.0839 145.613L66.0396 142.772L49.9953 139.93L35.5812 137.377M114.173 151.297L111.31 161.918C110.839 163.666 109.105 164.76 107.324 164.434L38.4327 151.819C36.7804 151.516 35.5803 150.077 35.5804 148.397L35.5812 137.377",
    stroke: "#313D53",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4314 151.819L107.323 164.435C109.104 164.761 110.838 163.666 111.309 161.918L114.171 151.297L35.5791 137.378L35.5791 148.397C35.5791 150.077 36.7792 151.517 38.4314 151.819Z",
    fill: "#F7BA97",
    stroke: "#313D53",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9351 166.12C45.5018 165.857 44.5532 164.482 44.8162 163.049L46.5486 153.61L59.7232 156.028L57.9909 165.467C57.7278 166.9 56.3526 167.849 54.9193 167.586L46.9351 166.12Z",
    fill: "white",
    stroke: "#313D53",
    strokeWidth: 4
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M82.9293 172.73C81.496 172.467 80.5473 171.092 80.8104 169.659L82.5427 160.22L95.7174 162.638L93.985 172.077C93.7219 173.51 92.3468 174.459 90.9135 174.195L82.9293 172.73Z",
    fill: "white",
    stroke: "#313D53",
    strokeWidth: 4
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M56.999 41.4429L60.3072 46.389",
    stroke: "#313D53",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuy);
export default __webpack_public_path__ + "static/media/buy.674ac022c832e92322e47d8b0a129391.svg";
export { ForwardRef as ReactComponent };